export const STORAGE_USER_KEY = 'user'
export const DATE_APP_FORMAT = 'MMM. d, yyyy'
export const DATE_DATA_FORMAT = 'YYYY-MM-DD'
export const DATE_MOMENT_DATA_FORMAT = 'M/D/YYYY'
export const DATE_MOMENT_FORMAT = 'MMM. D, YYYY'
export const DATE_FULL_YEAR = 'YYYY'
export const DATE_FILE_FORMAT = `${DATE_DATA_FORMAT}-HHmmss`
export const UNKNOWN_VALUE = 'Unknown'
export const TWITTER_URL = 'https://twitter.com'
export const IMAGE_REGEX = new RegExp('(.*?).(jpg|jpeg|bmp|gif|png)$')
export const IMAGE_MAX_SIZE = 1048576
export const DEFAULT_PAGINATION_SIZE = 25
export const DEMOGRAPHICS_ORDER = ['Gender', 'Race', 'Ethnicity', 'Ancestry']
export const MINIMUM_GPA = 'Minimum GPA'
export const MINIMUM_CLASS_RANK = 'Minimum Class Rank Percentage'
export const MINIMUM_OVERALL_SAT = 'Minimum Overall SAT'
export const MINIMUM_OVERALL_ACT = 'Minimum ACT Composite'
export const MAXIMUM_AGI = 'Maximum AGI'
export const MAXIMUM_EFC = 'Maximum EFC'
export const DEFAULT_PAGE_SIZE = 25
export const TOOLTIP_LINK_POPUP_TIME = 500
export const ORDER_DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC',
}
export const YOUR_PROGRAM_STATUSES = {
  UNDER_REVIEW: 'Under Review',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
}
export const PROGRAM_STATUSES = {
  SOURCED: 'SOURCED',
  DRAFT: 'DRAFT',
  QA_READY: 'QA_READY',
  VERIFIED: 'VERIFIED',
  NOT_ACTIVE: 'NOT_ACTIVE',
  NO_LONGER_AVAILABLE: 'NO_LONGER_AVAILABLE',
}
export const STAGED_STATUS = {
  MEMBER_DRAFTING: 'MEMBER_DRAFTING',
  SUBMITTED_FOR_REVIEW: 'SUBMITTED_FOR_REVIEW',
  PENDING_REVIEW: 'PENDING_REVIEW',
  REVIEWED: 'REVIEWED',
}
export const SCHOLARSHIPS = 'SCHOLARSHIPS'
export const STAGED_SCHOLARSHIPS = 'STAGED_SCHOLARSHIPS'

export const SCHOLARSHIP_PATH =
  'ScholarshipProgramCollection.ScholarshipProgramInfo'

export const RETAIN_FILTER_PATHS = [
  '/search/advanced',
  '/programs-search',
  '/member-detail-search',
  '/search/advanced/organizations',
  '/search/advanced/programs',
  '/organization-detail-search',
]
export const DEFAULT_SEARCH_FILTER = {
  paginated: false,
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  inGoApply: true,
}

export const INDIVIDUAL_ORGANIZATION = '[Individual Member]'

export const UNITED_STATES = 'US'
export const CANADA = 'CA'
export const MEXICO = 'MX'
export const KNOWN_COUNTRIES = [UNITED_STATES, CANADA]

export const ORGANIZATION_SEARCH_DEFAULT_PARAMS = {
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  sort: 'name',
  sortDirection: ORDER_DIRECTION.ASC,
}

export const STATUS_VERIFIED = 'VERIFIED'

export const MIN_GPA = 1
export const MAX_GPA = 5
export const MIN_CLASS_RANK = 0
export const MAX_CLASS_RANK = 100

// DEFAULT PARAMETERS
export const PROGRAM_SEARCH_DEFAULT_PARAMS = {
  paginated: false,
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  sort: 'programName',
  sortDirection: ORDER_DIRECTION.ASC,
  inGoApply: true,
  member: true,
}

export const ROW_DATE_FILTERS = ['openDateRange', 'closeDateRange']

export const PROGRAM_COLUMNS = [
  'programName',
  'blurb',
  'logoURL',
  'openDate',
  'closeDate',
  'criteriaDescription',
  'scholarshipMaximumAward',
  'criterias',
  'eligibilityCriteriaDescription',
  'nspaMemberId',
  'isNspaMember',
  'programOrganizationName',
  'visibility',
]

export const ORG_COLUMNS = [
  'isNspaMember',
  'programOrganizationName',
  'logoURL',
  'isNspaMember',
  'orgType',
  'orgCategory',
  'stateCategory',
  'phoneNumberCategory',
  'numPrograms',
  'staffCount',
  'yearFirstScholarship',
  'totalDollarAmount',
  'totalAwardAmount',
  'totalNumberStudents',
  'scholarshipMaximumAwardOrganization',
  'scholarshipMinimumAwardOrganization',
  'renewable',
  'meritBasedOrganization',
  'needBasedOrganization',
  'degreeBeingSought',
]

// DEFAULT PARAMETERS
export const PROGRAM_SEARCH_DEFAULT_ORG_PARAMS = {
  sort: 'programOrganization',
  group: ORG_COLUMNS,
}
